import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Modals/ModalComponent/Modal';
export default class FullScreenModal extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const output = /*#__PURE__*/React.createElement(Modal, {
      open: props.open,
      onClose: props.onClose,
      title: props.title,
      "hide-controls": true,
      "scroll-area": ".front-page, .back-page",
      bemit: props.bemit || ['fullscreen', 'simple', 'spaces'],
      src: props.trigger_src
    }, props.children);
    return output;
  }
}
FullScreenModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  trigger_src: PropTypes.object
};
